import vtkSTLReader from './STLReader';

export default {
  vtkSTLReader,
};
